import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import blogData from "../data/blogData";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Blog() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const showData = blogData.map((el, index) =>
        <div key={index} className="js-scroll fade-top w-100 w-[32%] rounded-[8px] shadow-[0px_0px_10px_#00000038]">
            <div className="w-full h-[360px]">
                <img className="w-full h-full object-cover rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="flex flex-col justify-between gap-[15px] p-[20px]">
                <div className="flex flex-col gap-[5px]">
                    <div className="font-bold text-[22px] capitalize">{t(`${el.title}`)}</div>
                    <p>{t(`${el.details.length > 75 ? el.details.substring(0, 75) + '...' : el.details}`)}</p>
                </div>
                <Link to={`/blogDetails/${el.id}`} className="w-fit flex flex-col">
                    <div className="font-bold capitalize text-[#0B2C3D]">{t("Read More")}</div>
                    <img className="h-[3px]" src={require("../../assets/icons/line-text.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <>
            <section className="blog-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">{t("Important Topics")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="btmAni20002 flex flex-col gap-[3px]">
                        <div className="text-[30px] font-bold text-[#0B2C3D]">{t("Blogs")}</div>
                        <img className="h-[3px]" src={require("../../assets/icons/line-text.svg").default} alt="" />
                    </div>
                    <div className="f-col flex flex-wrap gap-[20px] justify-between">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}